<template>
  <v-form
    ref="form"
    v-model="valid"
    @submit.prevent="submit"
  >
    <label class="input-label mb-2 ml-2">Działanie</label>
    <v-select
      v-model="selectedAction"
      v-bind="props.select"
      :items="actions"
      :rules="[rules.objectEmpty]"
      item-text="label"
      return-object
      placeholder="Wybierz działanie"
      class="mb-4"
      @change="comment = ''"
    />

    <label class="input-label mb-2 ml-2">Komentarz</label>
    <v-textarea
      v-model="comment"
      v-bind="props.textField"
      :readonly="!selectedAction.commentable"
      :rules="selectedAction.commentRequired ? [rules.required] : []"
      :placeholder="selectedAction.commentable ? '' : 'Wybierz działanie, aby dodać komentarz.'"
      no-resize
      height="120"
    />

    <v-btn
      class="mt-2"
      color="primary"
      depressed
      type="submit"
      :loading="isActionProcessing"
    >
      Wyślij
    </v-btn>
  </v-form>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import props from '@/helpers/componentsProps';
import rules from '@/helpers/validators';

export default {
  props: {
    actions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      props,
      rules,
      valid: false,
      selectedAction: {},
      comment: '',
    };
  },
  computed: {
    ...mapState(['isActionProcessing']),
  },
  methods: {
    ...mapActions('dkoCooperation', ['performAction']),
    submit() {
      if (!this.$refs.form.validate()) return;
      this.performAction({
        actionName: this.selectedAction.name,
        comment: this.comment,
      });
    },
  },
};
</script>
